import DOMPurify from "dompurify";

/**
 * Xss Filter
 * @param input
 * @returns {boolean}
 */
export const containsXss = (input) => {
    // const sanitizedInput = DOMPurify.sanitize(input);
    // return input !== sanitizedInput;
    if (typeof input !== 'string') return false;

    const lower = input.toLowerCase();

    // 직접적인 XSS 키워드 필터링
    const xssPattern = /<script|onerror=|onload=|javascript:|<iframe|<img/i;

    if (xssPattern.test(lower)) return true;

    // DOMPurify 비교
    const sanitized = DOMPurify.sanitize(input);
    return input !== sanitized;
}